// theme/src/gift-wrap/src/packaging/components/SealPicker.jsx
import React from 'react';
import Knob from '../../components/Knob';
import Select from '../../components/Select';
import { useLocale } from '../../context/LocaleContext';
import styles from '../packaging.module.css';

/**
 * The select shows just the letter or design: stamp variants are titled "Initial: A" to "Initial: Z" (plus designs
 * such as "Doodle Heart"), so "Initial: " is dropped. Display only; the cart keeps the full variant title.
 * @param {string} title
 * @returns {string}
 */
export const sealOptionLabel = (title = '') => title.replace(/^initial:\s*/i, '') || title;

/**
 * Figma frames 4-5 seal row, laid out like the bag name row: "<title> +£x" with a switch on the right, off by
 * default. On, it shows the "Choose Initial" select over every variant of the stamp product, pre-filled with the
 * current one (the first variant until a letter is chosen). The row price is the current variant's price.
 */
export function SealPicker({ id, title, helper = '', label, stamp, on, onToggle, value, onChange }) {
  const { formatPrice } = useLocale();
  const variants = stamp?.variants || [];
  const current = variants.find((v) => v.id === value) ?? variants[0];
  const options = variants.map((v) => ({ label: sealOptionLabel(v.title), value: v.id }));
  const toggleId = `${id}-toggle`;

  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader}>
        {/* Knob ignores aria-label; it labels its hidden checkbox through `id`. */}
        <label htmlFor={toggleId} className={styles.field}>
          <span className={styles.fieldLabel}>{title}</span>
          {helper && <span className={styles.helper}>{helper}</span>}
        </label>
        {current && <span>+{formatPrice({ amount: current.price })}</span>}
        <Knob id={toggleId} isEnabled={on} onChange={onToggle} />
      </div>
      {on && (
        <>
          <label htmlFor={id} className={styles.helper}>
            {label}
          </label>
          <Select id={id} name={id} options={options} value={value} onChange={onChange} placeholder="Choose Initial" />
        </>
      )}
    </div>
  );
}
